import { queryOptions, type UseQueryOptions } from '@tanstack/react-query';
import type {
  GetOwnUserProfileStatsData,
  GetUserProfileStatsResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

export const getMyProfileStatsKey = () => ['profiles', '@me', 'stats'] as const;

const getMyProfileStatsUrl: GetOwnUserProfileStatsData['url'] =
  'profiles/@me/stats';

export const getMyProfileStatsOptions = <T = GetUserProfileStatsResponse>(
  options?: Omit<
    UseQueryOptions<GetUserProfileStatsResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions<GetUserProfileStatsResponse, unknown, T>({
    queryKey: getMyProfileStatsKey(),
    queryFn: () =>
      PrivateApi.get(getMyProfileStatsUrl).json<GetUserProfileStatsResponse>(),
    ...options,
  });
